module.exports = __webpack_public_path__ + "static/media/card-favorites.23878d9a.svg";